<template>
    <div>
        <el-row class="card-margin-bottom">
            <el-col :span="24">Olet tuomassa {{ maara }} huonekorttia vastuuyksikköön {{ vastuuyksikkoNimi }}</el-col>
        </el-row>

        <el-table :data="huonekorttiRows" stripe class="card-margin-bottom">
            <el-table-column prop="nimi" label="Huonekortti" min-width="200" />
            <el-table-column label="Tilojen määrä" width="160">
                <template #default="{ row }">
                    <el-input-number
                        :model-value="getTilojenMaara(row.id)"
                        @update:model-value="(val: number | undefined) => setTilojenMaara(row.id, val ?? 0)"
                        :min="0"
                        size="small" />
                </template>
            </el-table-column>
            <el-table-column type="expand" width="50">
                <template #default="{ row }">
                    <div style="padding: 10px 20px;">
                        <div
                            v-for="(tila, index) in (tilatPerHuonekortti[row.id] ?? [])"
                            :key="index"
                            style="margin-bottom: 8px;">
                            <el-input
                                :model-value="tila.tilatunnus ?? ''"
                                @update:model-value="(val: string) => setTilatunnus(row.id, index, val)"
                                :placeholder="'Tilatunnus ' + (index + 1)"
                                size="small" />
                        </div>
                        <div v-if="getTilojenMaara(row.id) === 0" style="color: var(--el-text-color-secondary);">
                            Ei tiloja
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <el-row class="card-margin-bottom">
            <el-col :span="24">
                <el-checkbox v-model="kopioiLiitteet" label="Kopioi myös huonekorttien liitteet" border />
            </el-col>
        </el-row>
        <el-row justify="end">
            <el-col :push="18">
                <el-button size="small" type="danger" class="button" @click="peruuta">Peruuta</el-button>
                <el-button size="small" type="success" class="button" @click="hyvaksy">Tuo huonekortit</el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useComTuonti } from "./tuonti"

const {
    huonekortit,
    vastuuyksikko,
    vastuuyksikot,
    kopioiLiitteet,
    tilatPerHuonekortti,
    setTilojenMaara,
    setTilatunnus,
    peruuta,
    hyvaksy
} = useComTuonti()

const maara = computed(() => huonekortit.value.length)
const vastuuyksikkoNimi = computed(() => vastuuyksikot.value?.find((v) => v.id === vastuuyksikko.value)?.nimi)

const huonekorttiRows = computed(() =>
    huonekortit.value.map((h) => ({
        id: h.id,
        nimi: h.nimi
    }))
)

const getTilojenMaara = (id: number) => {
    return tilatPerHuonekortti.value[id]?.length ?? 0
}
</script>

<style scoped>
.button {
    position: relative;
    top: 34px;
    z-index: 1000000;
}
</style>
